/**
 * Newsletter Section - Fallback Handler
 * Workboots Direct
 * Only runs when Klaviyo library is not available
 */

(function() {
  // Only run if Klaviyo is not loaded
  if (typeof KlaviyoSubscribe === 'undefined') {
    
    class NewsletterKlaviyo {
      constructor(sectionId) {
        this.sectionId = sectionId;
        this.form = document.getElementById(`newsletter-klaviyo-form-${sectionId}`);
        
        if (!this.form) return;
        
        this.listId = this.form.dataset.listId;
        this.integrationType = this.form.dataset.integrationType || 'shopify';
        this.successMsg = this.form.querySelector('.newsletter-klaviyo__success');
        this.errorMsg = this.form.querySelector('.newsletter-klaviyo__error');
        this.submitBtn = this.form.querySelector('.newsletter-klaviyo__button');
        
        this.init();
      }
      
      init() {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }
      
      async handleSubmit(e) {
        e.preventDefault();
        
        const email = this.form.querySelector('input[name="email"]').value;
        
        this.hideMessages();
        this.setLoading(true);
        
        try {
          await this.subscribe(email);
          
          if (this.successMsg) {
            this.successMsg.style.display = 'flex';
            this.form.reset();
          }
          
        } catch (error) {
          console.error('Newsletter subscription error:', error);
          if (this.errorMsg) {
            this.errorMsg.querySelector('span').textContent = 'Something went wrong. Please try again.';
            this.errorMsg.style.display = 'flex';
          }
        } finally {
          this.setLoading(false);
        }
      }
      
      async subscribe(email) {
        await this.subscribeToShopify(email);
      }
      
      async subscribeToShopify(email) {
        const formData = new URLSearchParams();
        formData.append('contact[email]', email);
        formData.append('contact[tags]', 'newsletter');
        
        const response = await fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
        
        if (!response.ok && response.status !== 200) {
          const text = await response.text();
          if (!text.includes('success') && !text.includes('thank')) {
            throw new Error('Shopify submission failed');
          }
        }
      }
      
      hideMessages() {
        if (this.successMsg) this.successMsg.style.display = 'none';
        if (this.errorMsg) this.errorMsg.style.display = 'none';
      }
      
      setLoading(loading) {
        if (this.submitBtn) {
          this.submitBtn.disabled = loading;
          
          if (loading) {
            this.submitBtn.classList.add('loading');
          } else {
            this.submitBtn.classList.remove('loading');
          }
        }
      }
    }

    // Initialize on DOM ready
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('[data-section-type="newsletter-klaviyo"]').forEach(section => {
        const sectionId = section.dataset.sectionId;
        if (sectionId) {
          new NewsletterKlaviyo(sectionId);
        }
      });
    });

    // Shopify design mode
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(e) {
        const section = e.target;
        if (section.dataset.sectionType === 'newsletter-klaviyo') {
          const sectionId = section.dataset.sectionId;
          if (sectionId) {
            new NewsletterKlaviyo(sectionId);
          }
        }
      });
    }
    
  } else {
    console.log('Klaviyo library loaded - using Klaviyo form handler');
  }
})();
